import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { transitionDurationSeconds } from "./tabConstants";
import { tabsTheme } from "./tabsTheme";
export var TabUnderlineStyled = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: 0;\n    left: ", "px;\n    width: ", ";\n    height: ", ";\n    background-color: ", ";\n\n    ", "\n"])), function (_ref) {
  var leftPx = _ref.leftPx;
  return leftPx;
}, function (_ref2) {
  var widthPlusUnit = _ref2.widthPlusUnit;
  return widthPlusUnit;
}, function (_ref3) {
  var _ref3$height = _ref3.height,
    height = _ref3$height === void 0 ? "2px" : _ref3$height;
  return height;
}, function (_ref4) {
  var backgroundColor = _ref4.backgroundColor;
  return backgroundColor;
}, function (_ref5) {
  var underlineTransition = _ref5.underlineTransition,
    themeMode = _ref5.themeMode;
  if (underlineTransition) {
    return "transition: width ".concat(transitionDurationSeconds, "s ").concat(tabsTheme.underlineAnimation(themeMode), ", left ").concat(transitionDurationSeconds, "s ").concat(tabsTheme.underlineAnimation(themeMode), ";");
  }
});
TabUnderlineStyled.displayName = "TabUnderlineStyled";
//# sourceMappingURL=TabUnderlineStyled.js.map